import { blogPosts } from '@/app/[lang]/blog/lib/posts'

/**
 * Blog post slug eşleştirmesi için yardımcı fonksiyonlar
 */

export type Language = 'en' | 'tr'

/**
 * Verilen slug ve dil için karşılık gelen diğer dildeki slug'ı bulur
 */
export function getCorrespondingSlug(currentSlug: string, currentLang: Language, targetLang: Language): string | null {
  // Mevcut slug'a sahip blog post'u bul
  const post = blogPosts.find(post => {
    const currentSlugKey = `slug_${currentLang}` as keyof typeof post
    return post[currentSlugKey] === currentSlug
  })

  if (!post) {
    return null
  }

  // Hedef dildeki slug'ı döndür
  const targetSlugKey = `slug_${targetLang}` as keyof typeof post
  return post[targetSlugKey] as string
}

/**
 * Blog post URL'i olup olmadığını kontrol eder
 */
export function isBlogPostUrl(pathname: string): boolean {
  return /^\/[a-z]{2}\/blog\/post\//.test(pathname)
}

/**
 * Blog post URL'inden slug'ı çıkarır
 */
export function extractSlugFromBlogUrl(pathname: string): string | null {
  const match = pathname.match(/^\/[a-z]{2}\/blog\/post\/([^\/]+)/)
  return match ? match[1] : null
}

/**
 * Blog post için dil değiştirilmiş URL'i oluşturur
 */
export function getBlogPostLanguageUrl(pathname: string, currentLang: Language, targetLang: Language): string {
  const slug = extractSlugFromBlogUrl(pathname)

  if (!slug) {
    // Eğer slug bulunamazsa, genel blog sayfasına yönlendir
    return `/${targetLang}/blog`
  }

  const correspondingSlug = getCorrespondingSlug(slug, currentLang, targetLang)

  if (!correspondingSlug) {
    // Eğer karşılık gelen slug bulunamazsa, genel blog sayfasına yönlendir
    return `/${targetLang}/blog`
  }

  return `/${targetLang}/blog/post/${correspondingSlug}`
}

/**
 * Genel URL dil değiştirme fonksiyonu (blog post'lar için özel mantık dahil)
 */
export function getLanguageSwitchedUrl(pathname: string, currentLang: Language, targetLang: Language): string {
  // Blog post sayfası kontrolü
  if (isBlogPostUrl(pathname)) {
    return getBlogPostLanguageUrl(pathname, currentLang, targetLang)
  }

  // Diğer sayfalar için standart dil değiştirme
  return `/${targetLang}${pathname?.replace(/^\/(en|tr)/, '')}`
}
